import React from "react";
import { View } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import CandidateRejectionViewModel from "viewModels/finance/customerRefunds/customerRefundCandidates/candidateRejectionViewModel";
import { observer } from "mobx-react-lite";
import { Form, Modal } from "react-bootstrap";
import { Input } from "@frui.ts/bootstrap";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import Button from "@edaz/edazkit/Button";
import { preventDefault } from "@frui.ts/views/dist";

export const CandidateRejectionView: ViewComponent<CandidateRejectionViewModel> = observer(({ vm }) => {
  return (
    <Modal
      show={true}
      onHide={vm.requestClose}
      centered
      dialogClassName="confirm-dialog"
      backdropClassName="confirm-dialog-backdrop">
      <Modal.Body>
        <Form onSubmit={preventDefault(vm.onRejectSubmit)}>
          <View vm={vm.alertsViewModel} useLifecycle={true} />
          <div
            className="mb-4 border border-2 border-danger rounded-circle d-flex justify-content-center align-items-center mx-auto"
            style={{ width: 64, height: 64 }}>
            <Icon icon={IconType.Error} width={40} height={40} />
          </div>
          <h3 className="text-center">{vm.translate("title")}</h3>
          <Form.Group>
            <Form.Label>{vm.translate("rejectionReason")}</Form.Label>
            <Input as="textarea" target={vm.rejection} property="rejectionReason" />
          </Form.Group>
          <ButtonToolbar className="justify-content-center d-flex">
            <Button variant="light" onClick={vm.requestClose}>
              {vm.translate("cancel")}
            </Button>
            <Button variant="danger" type="submit">
              {vm.translate("reject")}
            </Button>
          </ButtonToolbar>
        </Form>
      </Modal.Body>
    </Modal>
  );
});

registerView(CandidateRejectionView, CandidateRejectionViewModel);
